import Image from "react-graceful-image";
import Shirt from "../Shirt";
import { getPlayerPhotoUrl } from "../../helpers/utils";
import styles from "./index.module.scss";

const getSizeClassName = (size) => {
  if (size === "lg") {
    return styles.lgPhoto;
  }
  if (size === "sm") {
    return styles.smPhoto;
  }

  return styles.photo;
};

const PlayerImage = ({ player, size, lazy = true, isSmallIcon = false }) => {
  const imgProps = {
    className: getSizeClassName(size),
    src: getPlayerPhotoUrl(player),
  };

  if (player === null) return null;

  return process.env.REACT_APP_PHOTO_ENABLED ? (
    lazy ? (
      <Image {...imgProps} />
    ) : (
      <img {...imgProps} alt="" />
    )
  ) : (
    <Shirt
      isSmall={isSmallIcon}
      teamId={player?.teamId}
      number={player?.number}
      showAge={false}
    />
  );
};

export default PlayerImage;
